import { DataBean } from "../DataBean";

export class FixedAssetCatalog extends DataBean {


    public async getFixedAssetCatalog(idFixedAsset:any,prefix:any,accountID:any,page:any,recordsPerPage:any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "com.advantage.shared.Report_getFixedAssetCatalog_Number_String_Number_Number_Number", [idFixedAsset,prefix,accountID,page,recordsPerPage]);
    }
}